import { SEMINAR } from "@/seminars";

export const DICTIONARIES = SEMINAR.dictionaries;
export const getDictionary = (lang) => DICTIONARIES[lang] || DICTIONARIES.en;
